import request from "./../utils/request";

export const TICIMAX_API = {
    listMembers(cursor, filters, sort) {
        return request({
            url: `/ticimax/list-members`,
            method: "post",
            data: {
                cursor,
                filters,
                sort,
            },
        });
    },
    getTypes() {
        return request({
            url: `/ticimax/types`,
            method: "get",
        });
    },
    listExampleMembersByFilterGroups(filterGroups, cursor, download) {
        return request({
            url: `/ticimax/find-members-by-filter-groups`,
            method: "post",
            data: {
                filterGroups,
                cursor,
            },
            params: {
                download,
            },
        });
    },
    createAutomationRule(name, filterGroups, rrule, selectedTemplate, templateParams, channel, resendEnabledAfterDays) {
        return request({
            url: `/ticimax/create-automation-rule`,
            method: "post",
            data: {
                name,
                filterGroups,
                rrule,
                selectedTemplate,
                templateParams,
                channel,
                resendEnabledAfterDays,
            },
        });
    },
    listAutomationRules() {
        return request({
            url: `/ticimax/automation-rules`,
            method: "get",
        });
    },
    deleteAutomationRule(id) {
        return request({
            url: `/ticimax/automation-rules/${id}/delete`,
            method: "get",
        });
    },
    stopAutomationRule(id) {
        return request({
            url: `/ticimax/automation-rules/${id}/stop`,
            method: "get",
        });
    },
    startSyncMembers(dayCount = 1) {
        return request({
            url: `/ticimax/start-sync-members/${dayCount}`,
            method: "get",
        });
    },
};
